// Maps API errors to catalogue copy by code (the server's English message is never shown, D-013).
import { i18n, t } from "@ady/i18n";
import { ApiError, StepUpCancelled } from "./client";

export function errorMessage(err: unknown): string {
  // The user closed "Confirm it's you": nothing happened (api/client.ts asks for every call).
  if (err instanceof StepUpCancelled) return t("errors.stepUpCancelled");
  if (!(err instanceof ApiError)) return t("errors.generic");
  if (err.code === "network") return t("errors.network");
  if (err.code === "rate_limited")
    return t("auth.errors.rate_limited", { seconds: err.retryAfterS ?? 60 });
  if (err.code.startsWith("auth."))
    return i18n.tDynamic(`auth.errors.${err.code.slice(5)}`, "auth.errors.generic");
  if (err.code === "authz.forbidden") return t("errors.forbidden");
  if (err.code === "not_found" || err.code === "tenant.not_member") return t("errors.notFound");
  if (err.code === "dependency.activation_required") return t("errors.activationRequired");
  if (err.code.startsWith("entitlement.")) return t("errors.entitlement");
  if (err.code === "tenant.org_locked") return t("errors.orgLocked");
  // D-064 Adyvance Wallet: what a shop can fix itself, in plain words.
  if (err.code.startsWith("billing."))
    return i18n.tDynamic(`adyWallet.errorCodes.${err.code.slice(8)}`, "errors.generic");
  if (err.code.startsWith("validation.")) return t("errors.validation");
  return t("errors.generic");
}

export const isUnauthenticated = (err: unknown) => err instanceof ApiError && err.status === 401;
